import "@/App.css";
import ComingSoon from "./pages/ComingSoon";

function App() {
  return <ComingSoon />;
}

export default App;

/*
  Full site — uncomment this block and remove the ComingSoon App above when the site should open.

import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HeidiWidget from "./components/HeidiWidget";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";

const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Magazine = lazy(() => import("./pages/Magazine"));
const ArticleDetail = lazy(() => import("./pages/ArticleDetail"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Profile = lazy(() => import("./pages/Profile"));
const MemberProfile = lazy(() => import("./pages/MemberProfile"));
const Explore = lazy(() => import("./pages/Explore"));
const CategoryPage = lazy(() => import("./pages/CategoryPage"));
const Events = lazy(() => import("./pages/Events"));
const MyEvents = lazy(() => import("./pages/MyEvents"));
const Concierge = lazy(() => import("./pages/Concierge"));
const Feed = lazy(() => import("./pages/Feed"));
const Studio = lazy(() => import("./pages/Studio"));
const Messages = lazy(() => import("./pages/Messages"));
const Connections = lazy(() => import("./pages/Connections"));
const Discussion = lazy(() => import("./pages/Discussion"));
const ThreadDetail = lazy(() => import("./pages/ThreadDetail"));
const Stars = lazy(() => import("./pages/Stars"));
const Archives = lazy(() => import("./pages/Archives"));
const Contact = lazy(() => import("./pages/Contact"));
const Membership = lazy(() => import("./pages/Membership"));
const Admin = lazy(() => import("./pages/Admin"));
const Advertise = lazy(() => import("./pages/Advertise"));
const Advertisements = lazy(() => import("./pages/Advertisements"));
const PrivacyPolicy = lazy(() => import("./pages/legal/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/legal/TermsOfService"));
const CookiePolicy = lazy(() => import("./pages/legal/CookiePolicy"));
const AdminImageLibrary = lazy(() => import("./pages/AdminImageLibrary"));
const BecomePartner = lazy(() => import("./pages/BecomePartner"));
const CityPage = lazy(() => import("./pages/CityPage"));

function PageFallback() {
  return <div className="min-h-[60vh]" />;
}

function Layout({ children }) {
  const location = useLocation();
  const bare = location.pathname === "/login" || location.pathname === "/signup";
  if (bare) return children;
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <HeidiWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Toaster position="top-center" richColors />
            <Layout>
              <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/explore" element={<ProtectedRoute><Explore /></ProtectedRoute>} />
                <Route path="/stars" element={<ProtectedRoute><Stars /></ProtectedRoute>} />
                <Route path="/archives" element={<ProtectedRoute><Archives /></ProtectedRoute>} />
                <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
                <Route path="/membership" element={<ProtectedRoute><Membership /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                <Route path="/admin/images" element={<ProtectedRoute><AdminImageLibrary /></ProtectedRoute>} />
                <Route path="/advertise" element={<ProtectedRoute><Advertise /></ProtectedRoute>} />
                <Route path="/advertisements" element={<ProtectedRoute><Advertisements /></ProtectedRoute>} />
                <Route path="/category/partnership" element={<CategoryPage slugOverride="partnership" />} />
                <Route path="/become-a-partner" element={<BecomePartner />} />
                <Route path="/city/:slug" element={<ProtectedRoute><CityPage /></ProtectedRoute>} />
                <Route path="/category/:slug" element={<ProtectedRoute><CategoryPage /></ProtectedRoute>} />
                <Route path="/magazine" element={<ProtectedRoute><Magazine /></ProtectedRoute>} />
                <Route path="/magazine/:id" element={<ProtectedRoute><ArticleDetail /></ProtectedRoute>} />
                <Route path="/members/:id" element={<ProtectedRoute><MemberProfile /></ProtectedRoute>} />
                <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
                <Route path="/discussion" element={<ProtectedRoute><Discussion /></ProtectedRoute>} />
                <Route path="/discussion/:id" element={<ProtectedRoute><ThreadDetail /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
                <Route path="/my-events" element={<ProtectedRoute><MyEvents /></ProtectedRoute>} />
                <Route path="/concierge" element={<ProtectedRoute><Concierge /></ProtectedRoute>} />
                <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
                <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                <Route path="/connections" element={<ProtectedRoute><Connections /></ProtectedRoute>} />
                <Route path="/privacy-policy" element={<ProtectedRoute><PrivacyPolicy /></ProtectedRoute>} />
                <Route path="/terms-of-service" element={<ProtectedRoute><TermsOfService /></ProtectedRoute>} />
                <Route path="/cookie-policy" element={<ProtectedRoute><CookiePolicy /></ProtectedRoute>} />
              </Routes>
              </Suspense>
            </Layout>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
*/
